import { withRouter } from 'react-router';
import CustomerPresentCardPayment from './CustomerPresentCardPayment';

export default withRouter(CustomerPresentCardPayment);
